"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const react_intl_1 = require("react-intl");
exports.messages = (0, react_intl_1.defineMessages)({
    searchPlaceholder: {
        id: 'components/Agent/List:searchPlaceholder',
        defaultMessage: 'Search',
    },
});
//# sourceMappingURL=messages.js.map